module.exports = __webpack_public_path__ + "img/img_26.f4dcba6c.png";